import DaisyBaseService from './../../../services/DaisyBaseService';

export default class PackingDaisyService extends DaisyBaseService {

    constructor($injector) {
        super($injector);

        this.$cookies = $injector.get('$cookies');
        this.$q = $injector.get('$q');
        this.baseUrl = this.baseUrl + 'MDEPacking/';
    }

    getUserId(){
        let user = this.$cookies.getObject('user');
        return user.USER_ID;
    }

    getPromise(result){
        let deferred = this.$q.defer();
        deferred.resolve(result);
        return deferred.promise;
    }

    getPackingSlip(number){
        // example = 7002045;
        let functionUrl = 'GetPackingSlipByNUMBER/';
        let data = {
            'USER_ID': this.getUserId(),
            'PACKING_SLIP_NUMBER': parseInt(number)
        };

        return this.doPost(functionUrl, data).then((response) => {
            if (response === false){
                return response;
            }

            if ('PACKING_SLIP' in response){
                return response;
            }
        });
    }

    getPackagingMeans(){
        let functionUrl = 'GetPackagingMeans/';
        let data = {};

        return this.doPost(functionUrl, data).then((response) => {
            return response;
        });
    }

    newPackage(packingMean, packingSlip){
        let functionUrl = 'NewPackage/';
        let data = {
            'USER_ID': this.getUserId(),
            'NEW_PACKAGE': {
                'PACKING_SLIP_ID': parseInt(packingSlip.PACKING_SLIP_ID),
                'PACKING_SLIP_TYPE': packingSlip.PACKING_SLIP_TYPE,
                'PACKAGING_MEAN_ID': packingMean.ID,
                'HEIGHT_IN_CM': packingMean.HEIGHT,
                'LENGTH_IN_CM': packingMean.LENGTH,
                'WIDTH_IN_CM': packingMean.WIDTH,
                'TARA_WEIGHT': 0,
                'GROSS_WEIGHT': 0,
                'GROSS_VOLUME': 0,
                'DESCRIPTION': '',
                'PACKAGE_ID': 0
            }
        };

        return this.doPost(functionUrl, data).then((response) => {
            return response;
        });
    }

    changePackage(packing, packingSlip){
        let functionUrl = 'ChangePackage/';
        let data = {
            'USER_ID': this.getUserId(),
            'NEW_PACKAGE': {
                'DESCRIPTION': packing.DESCRIPTION,
                'PACKING_SLIP_ID': packingSlip.PACKING_SLIP_ID,
                'PACKING_SLIP_TYPE': packingSlip.PACKING_SLIP_TYPE,
                'PACKAGING_MEAN_ID': packing.PACKAGING_MEAN_ID,
                'HEIGHT_IN_CM': parseInt(packing.HEIGHT_IN_CM),
                'LENGTH_IN_CM': parseInt(packing.LENGTH_IN_CM),
                'WIDTH_IN_CM': parseInt(packing.WIDTH_IN_CM),
                'TARA_WEIGHT': parseFloat(packing.TARA_WEIGHT),
                'GROSS_WEIGHT': parseFloat(packing.GROSS_WEIGHT),
                'GROSS_VOLUME': parseFloat(packing.GROSS_VOLUME),
                'PACKAGE_ID': packing.PACKAGE_ID
            }
        };

        return this.doPost(functionUrl, data).then((response) => {
            return response;
        });
    }

    duplicatePackage(packing, packingSlip, copies){
        let functionUrl = 'DuplicatePackage/';

        let data = {
            "PARAMETER": {
                "USER_ID": this.getUserId(),
                "PACKING_SLIP_ID": packingSlip.PACKING_SLIP_ID,
                "PACKING_SLIP_TYPE": packingSlip.PACKING_SLIP_TYPE,
                "PACKAGE_ID": packing.PACKAGE_ID,
                "COPIES": parseInt(copies),
            }
        };

        return this.doPost(functionUrl, data).then((response) => {
            return response;
        });
    }

    deletePackage(packageId, packingSlip){
        let functionUrl = 'DeletePackage/';
        let data = {
            'DELETE_PARAMETER': {
                'USER_ID': this.getUserId(),
                'PACKING_SLIP_ID': parseInt(packingSlip.PACKING_SLIP_ID),
                'PACKAGE_ID': packageId,
                'PACKING_SLIP_TYPE': packingSlip.PACKING_SLIP_TYPE
            }
        };

        return this.doPost(functionUrl, data).then((response) => {
            return response;
        });
    }

    printPackage(packageId){
        let functionUrl = 'PrintContentLabels/';
        let data = {
            'PARAMETER': {
                'USER_ID': this.getUserId(),
                'LABELS': [
                    {
                        "PACKAGE_ID": packageId,
                        "COPIES": 1
                    }
                ],
            }
        };

        return this.doPost(functionUrl, data).then((response) => {
            return response;
        });
    }

    printPackingSlip(packages){
        let functionUrl = 'PrintContentLabels/';
        let data = {
            'PARAMETER': {
                'USER_ID': this.getUserId(),
                'LABELS': [

                ],
            }
        };
        _.forEach(packages, (value, key) => {
            let packageData =  {
                "PACKAGE_ID": value.PACKAGE_ID,
                "COPIES": 1
            };
            data.PARAMETER.LABELS.push(packageData)
        });

        return this.doPost(functionUrl, data).then((response) => {
            return response;
        });
    }

    addItemsToPackage(packingSlip, packageId, itemAndQuantityArray){
        let functionUrl = 'AddItemsToPackage/';
        let data = {
            'USER_ID': this.getUserId(),
            'NEW_PACKAGE_ITEMS': []
        };

        _.forEach(itemAndQuantityArray, (item, key) => {
            let itemData = {
                'PACKAGE_ID': parseInt(packageId),
                'PACKING_SLIP_ITEM_ID': parseInt(item.item.PACKING_SLIP_ITEM_ID),
                'PACKING_SLIP_TYPE': packingSlip.PACKING_SLIP_TYPE,
                'QTY': parseFloat(item.qty),
                'QTY_UNIT_ID': parseInt(item.qty_unit_id),
                'SAVE_MEMO_COMMENT_JN' : false,
                'MEMO_COMMENT' : '',
                'SAVE_MEMO_TEXT_AFTER_POS_JN' : false,
                'MEMO_TEXT_AFTER_POS': '',
            };

            if (typeof item.item.editComment !== 'undefined' && item.item.editComment === true){
                itemData.SAVE_MEMO_COMMENT_JN = true;
                itemData.MEMO_COMMENT = item.item.COMMENT;
            }

            if (typeof item.item.editTextAfterPos !== 'undefined' && item.item.editTextAfterPos === true){
                itemData.SAVE_MEMO_TEXT_AFTER_POS_JN = true;
                itemData.MEMO_TEXT_AFTER_POS = item.item.TEXT_AFTER_POS;
            }

            data.NEW_PACKAGE_ITEMS.push(itemData)
        });

        return this.doPost(functionUrl, data).then((response) => {
            return response;
        });
    }

    removePackageItems(packingSlip, packageId, itemAndQuantityArray){
        let functionUrl = 'RemovePackageItems/';
        let data = {
            'USER_ID': this.getUserId(),
            'PACKAGE_ITEMS': []
        };

        _.forEach(itemAndQuantityArray, (value, key) => {
            let itemData = {
                'PACKAGE_ID': parseInt(packageId),
                'PACKING_SLIP_ITEM_ID': parseInt(value.item.PACKING_SLIP_ITEM_ID),
                'PACKING_SLIP_TYPE': packingSlip.PACKING_SLIP_TYPE,
                'QTY': parseFloat(value.qty),
                'QTY_UNIT_ID': parseInt(value.qty_unit_id)
            };
            data.PACKAGE_ITEMS.push(itemData)
        });

        return this.doPost(functionUrl, data).then((response) => {
            return response;
        });
    }

    addPackingSlipToPackage(packingSlip, packageNumber){
        let functionUrl = 'AddPackageToPackingSlip/';
        let data = {
            'PARAMETER': {
                'PACKAGE_NUMBER': packageNumber,
                'USER_ID': this.getUserId(),
                'PACKING_SLIP_ID': parseInt(packingSlip.PACKING_SLIP_ID),
                'PACKING_SLIP_TYPE': packingSlip.PACKING_SLIP_TYPE
            }
        };

        return this.doPost(functionUrl, data).then((response) => {
            return response;
        });
    }

    getShippingTypes(packingSlip){
        let functionUrl = 'GetShippingTypes/';
        let data = {
            'PARAMETER': {
                'USER_ID': this.getUserId(),
                'PACKING_SLIP_ID': parseInt(packingSlip.PACKING_SLIP_ID),
                'PACKING_SLIP_TYPE': packingSlip.PACKING_SLIP_TYPE
            }
        };

        return this.doPost(functionUrl, data).then((response) => {
            return response;
        });
    }

    getServiceCodes(packingSlip, shippingTypeId){
        let functionUrl = 'GetServiceCodes/';
        let data = {
            'PARAMETER': {
                'USER_ID': this.getUserId(),
                'PACKING_SLIP_ID': parseInt(packingSlip.PACKING_SLIP_ID),
                'PACKING_SLIP_TYPE': packingSlip.PACKING_SLIP_TYPE,
                'SHIPPING_TYPE_ID': parseInt(shippingTypeId)
            }
        };

        return this.doPost(functionUrl, data).then((response) => {
            return response;
        });
    }

    getDateStringValue(dateValue){
        if (typeof dateValue != 'object'){
            return '';
        }
        if (!(dateValue instanceof Date)){
            return '';
        }

        let dd  = dateValue.getDate().toString();
        let mm = (dateValue.getMonth()+1).toString(); // getMonth() is zero-based
        let year = dateValue.getFullYear().toString();

        dd = dd.length === 2 ? dd : "0" + dd[0]; // dd can be 1-9 and daisy wants 01
        mm = mm.length === 2 ? mm : "0" + mm[0]; // mm can be 1-9 and daisy wants 01
        return dd + '.' + mm + '.' + year;
    }

    getTimeStringValue(dateValue){
        if (typeof dateValue != 'object'){
            return '';
        }
        if (!(dateValue instanceof Date)){
            return '';
        }

        let hours = dateValue.getHours().toString();
        let minutes = dateValue.getMinutes().toString();
        hours = hours.length === 2 ? hours : "0" + hours[0]; // hours can be 1-9 and daisy wants 01
        minutes = minutes.length === 2 ? minutes : "0" + minutes[0]; // minutes can be 1-9 and daisy wants 01
        return hours + ':' + minutes;
    }

    getServiceCodeParamValue(serviceCodeParameter){
        if (serviceCodeParameter.TYPE.trim() == ''){
            return '';
        }
        if (typeof serviceCodeParameter.VALUE == 'undefined'){
            return '';
        }

        let parameterValue = serviceCodeParameter.VALUE;
        if (serviceCodeParameter.TYPE == 'DATE'){
            return this.getDateStringValue(serviceCodeParameter.VALUE);
        }
        else if (serviceCodeParameter.TYPE == 'TIME'){
            return this.getTimeStringValue(serviceCodeParameter.VALUE);
        }
        else if (serviceCodeParameter.TYPE == 'INTEGER'){
            return serviceCodeParameter.VALUE.toString();
        }
        else if (serviceCodeParameter.TYPE == 'VARCHAR'){
            return serviceCodeParameter.VALUE;
        }
    }

    transformServiceCode(serviceCode){
        let result = {
            "SERVICE_CODE_ID": serviceCode.SERVICE_CODE_ID,
            "PARAM1_VALUE": "",
            "PARAM2_VALUE": "",
            "PARAM3_VALUE": "",
            "ADDITION_FOR_ADDRESs": serviceCode.ADDITION_FOR_ADDRESs
        };

        for(let i = 0; i < 3; i++){
            result['PARAM' + (i+1) + '_VALUE'] = this.getServiceCodeParamValue(serviceCode.parameter[i]);
        }
        return result;
    }

    finishPacking(packingSlip, shippingTypeId, addedServiceCodes){
        let functionUrl = 'FinishPacking/';
        let serviceCodesForDaisy = new Array();

        if (typeof addedServiceCodes != 'undefined') {
            _(addedServiceCodes).forEach((serviceCode) => {
                serviceCodesForDaisy.push(this.transformServiceCode(serviceCode));
            });
        }

        let data = {
            'PARAMETER': {
                'USER_ID': this.getUserId(),
                'PACKING_SLIP_ID': parseInt(packingSlip.PACKING_SLIP_ID),
                'PACKING_SLIP_TYPE': packingSlip.PACKING_SLIP_TYPE,
                'SHIPPING_TYPE_ID': parseInt(shippingTypeId),
                SERVICE_CODES: serviceCodesForDaisy,
            }
        };

        return this.doPost(functionUrl, data).then((response) => {
            return response;
        });
    }

    getPackageSelection(packingSlip){
        let functionUrl = 'GetPackageSelection/';
        let data = {
            'PARAMETER': {
                'PACKING_SLIP_ID': parseInt(packingSlip.PACKING_SLIP_ID),
                'PACKING_SLIP_TYPE': packingSlip.PACKING_SLIP_TYPE,
            }
        };

        return this.doPost(functionUrl, data).then((response) => {
            return response;
        });
    }

    savePackingSlipItemComment(packingSlipItem, packingSlip){
        let functionUrl = 'SaveMemo/';

        let data = {
            'Request': {
                'USER_ID': this.getUserId(),
                "PACKING_SLIP_ITEM_ID": parseInt(packingSlipItem.PACKING_SLIP_ITEM_ID),
                "PACKING_SLIP_TYPE": packingSlip.PACKING_SLIP_TYPE,
                "MEMO_TYPE": "mtComment",
                "MEMO_TEXT": packingSlipItem.COMMENT
            }
        };

        return this.doPost(functionUrl, data).then((response) => {
            return response;
        });
    }

    savePackingSlipItemTextAfterPos(packingSlipItem, packingSlip){
        let functionUrl = 'SaveMemo/';

        let data = {
            'Request': {
                'USER_ID': this.getUserId(),
                "PACKING_SLIP_ITEM_ID": parseInt(packingSlipItem.PACKING_SLIP_ITEM_ID),
                "PACKING_SLIP_TYPE": packingSlip.PACKING_SLIP_TYPE,
                "MEMO_TYPE": "mtTextAfterPos",
                "MEMO_TEXT": packingSlipItem.TEXT_AFTER_POS
            }
        };

        return this.doPost(functionUrl, data).then((response) => {
            return response;
        });
    }


}